import { SingleSelectField } from "@dgs/core";
import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { UserResponsibilityType } from "../../../shared/types/userResponsibility";

interface Props {
	name: string;
	label: string;
	isParticipant: boolean;
	required?: boolean;
}

const allUserResponsibilityTypes: UserResponsibilityType[] = [
	"projectManager",
	"projectMember",
	"speaker",
	"participant",
];

export const UserResponsibilityTypeSelectField: FC<Props> = ({ name, label, required, isParticipant }) => {
	const { t } = useTranslation();

	const options = useMemo(() => {
		if (isParticipant) {
			return allUserResponsibilityTypes;
		}
		return allUserResponsibilityTypes.filter((type) => type !== "participant");
	}, [isParticipant]);

	return (
		<SingleSelectField
			name={name}
			label={label}
			required={required}
			disabled={isParticipant}
			options={options}
			getLabel={(value) => t(`userResponsibilityType.${value}`)}
			renderOption={(value) => (
				<div>
					<div>{t(`userResponsibilityType.${value}`)}</div>
					<small>{t(`userResponsibilityTypeDescription.${value}`)}</small>
				</div>
			)}
		/>
	);
};
